import type { Middleware, UnknownAction } from '@reduxjs/toolkit';
import { TagTypes } from '../../Api/Types/tagTypes';
import { cashDocumentsApi } from '../../Features/CashDocuments/Service/cashDocumentsApi';
import { reservationsApi } from '../../Features/Reservation';

const shouldRefreshReservationPaymentViews = (action: UnknownAction): boolean =>
  cashDocumentsApi.endpoints.create.matchFulfilled(action) ||
  cashDocumentsApi.endpoints.update.matchFulfilled(action) ||
  cashDocumentsApi.endpoints.delete.matchFulfilled(action);

export const cashDocumentsReservationRefreshMiddleware: Middleware =
  (storeApi) => (next) => (action) => {
    const result = next(action);

    if (!shouldRefreshReservationPaymentViews(action as UnknownAction)) {
      return result;
    }

    storeApi.dispatch(
      reservationsApi.util.invalidateTags([
        { type: TagTypes.Reservation, id: TagTypes.List },
        { type: TagTypes.ReservationPayment, id: TagTypes.List },
      ])
    );

    return result;
  };
